const logger = (str) => {
  if (typeof TRUCKERS === "undefined") {
    return;
  }
  if (TRUCKERS.PARAMS && TRUCKERS.PARAMS.LOGGER && TRUCKERS.PARAMS.LOGGER == 'ENABLE'){
    console.log(str)
  }
}
export default logger
